
import { debounce } from "lodash";
import UiButton from "~/components/UI/UiButton";
import SearchResult from "@/components/common/search/SearchResult";
import useEvents from "~/mixins/useEvents";
export default {
  name: "GlobalSearchPopup",
  components: {
    UiButton,
    SearchResult,
  },
  mixins: [useEvents],
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      search: "",
      searchDebounce: () => {},
      suggestionsListData: [],
      suggestionsLoading: false,
      suggestionsCount: 3,
    };
  },
  watch: {
    value: {
      handler(val) {
        if (!process.client) return;
        if (val) {
          document.body.style.overflow = "hidden";
          this.$nextTick(() => {
            this.$refs["search-input"].focus();
          });
        } else {
          document.body.style.overflow = "";
        }
      },
      immediate: true,
    },
    "$route.query": {
      handler(val) {
        if (!val.search) {
          this.search = "";
        }
      },
      deep: true,
    },
    search: {
      handler(val) {
        if (!val || val?.length < 1) {
          this.suggestionsListData = [];
          return;
        }
        this.suggestionsLoading = true;
        this.searchDebounce(val);
      },
      immediate: true,
    },
  },
  created() {
    this.search = this.$route.query.search;
  },
  mounted() {
    this.searchDebounce = debounce((val) => {
      this.getSuggestions();
      this.searchEvent(val);
    }, 400);
    document.addEventListener("keyup", this.onKeyUp);
  },
  beforeDestroy() {
    document.removeEventListener("keyup", this.onKeyUp);
  },
  methods: {
    closeModal() {
      this.$emit("input", false);
    },
    onKeyUp(evt) {
      if (evt.keyCode === 27) {
        this.closeModal();
      }
    },
    onSubmit() {
      if (this.$route.path.includes("catalog")) {
        const query = { page: 1, search: this.search };
        if (this.$route.query.sortBy) {
          query.sortBy = this.$route.query.sortBy;
        }
        this.$router
          .replace(
            // this.localePath({
            //   query: { ...this.$route.query, page: 1, search: this.search },
            // })
            this.localePath({
              query,
            })
          )
          ?.catch(() => {});
      } else {
        this.$router
          .push(this.localePath(`/catalog?search=${this.search}`))
          ?.catch(() => {});
      }
      this.closeModal();
    },
    onChange(e) {
      if (!e.target.value) {
        const newQuery = JSON.parse(JSON.stringify(this.$route.query));
        delete newQuery.search;
        this.$router.replace(
          this.localePath({
            query: newQuery,
          })
        )?.catch(() => {});
      }
    },
    clearSearch() {
      this.search = "";
      const newQuery = JSON.parse(JSON.stringify(this.$route.query));
      delete newQuery.search;
      this.$router.replace(
        this.localePath({
          query: newQuery,
        })
      )?.catch(() => {});
      this.closeModal();
    },
    async getSuggestions() {
      this.suggestionsLoading = true;
      try {
        const params = {
          search: this.search,
          count: this.suggestionsCount,
        };
        const { data } = await this.$api.products.getCatalog(params);
        this.suggestionsListData = data?.data?.map((product) => ({
          configuration_id:
            product?.selected_config?.configuration_id ||
            product?.variant_plp_image?.sku ||
            product?.default_config?.configuration_id,
          id: null,
          product_id: product.id,
          slug: product.slug,
          title:
            product?.selected_config?.mixedTranslation?.title ||
            product?.variant_plp_image?.mixedTranslation?.title ||
            product?.default_config?.mixedTranslation?.title ||
            product?.mixedTranslation?.title,
          vendor_model: product.vendor_model,
        })) || [];
      } catch (error) {
        this.suggestionsListData = [];
        console.log("error - ", error);
      } finally {
        this.suggestionsLoading = false;
      }
    },
  },
};
